import { combineReducers } from 'redux'
import {
  setOpenAppActiveActionType,
  setBreadcrumbActionType,
  setIsMeaningfulTimeActionType,
} from '../actions/uiState'

export default combineReducers({
  isSuggestOpenAppPopupActive: (state = false, action) => {
    if (action.type === setOpenAppActiveActionType) {
      return action.payload.isActive || false
    }

    return state
  },
  breadcrumb: (state = [], action) => {
    if (action.type === setBreadcrumbActionType) {
      return action.payload.breadcrumb || []
    }

    return state
  },
  isMeaningfulTime: (state = false, action) => {
    if (action.type === setIsMeaningfulTimeActionType) {
      return action.payload.isMeaningfulTime || false
    }

    return state
  },
})
